export interface PasswordStrength {
    score: number;
    label: string;
    colorClass: string;
}

export function getPasswordStrength(password: string): PasswordStrength {
    if (!password) {
        return { score: 0, label: 'Very weak', colorClass: 'strength-very-weak' };
    }

    let score = 0;
    if (password.length >= 8) score += 1;
    if (/[A-Z]/.test(password)) score += 1;
    if (/[a-z]/.test(password)) score += 1;
    if (/[0-9]/.test(password)) score += 1;
    if (/[^A-Za-z0-9]/.test(password)) score += 1;

    if (score <= 1) return { score, label: 'Very weak', colorClass: 'strength-very-weak' };
    if (score === 2) return { score, label: 'Weak', colorClass: 'strength-weak' };
    if (score === 3) return { score, label: 'Medium', colorClass: 'strength-medium' };
    if (score === 4) return { score, label: 'Strong', colorClass: 'strength-strong' };
    return { score, label: 'Very strong', colorClass: 'strength-very-strong' };
}
